<template>
  <div>
    <!-- 大图 -->
    <div class="banner">
      <img :src="image+banner" class="bannerimg">
    </div>
    <!-- 热点关注 -->
    <div class="hot">
      <div style="width:1295px;margin:auto">
      <div class="hottitle">热点关注</div>
      <!-- <p class="hotp">山东水产学会关于组织申报中国水产学会科普教育基地的通知</p> -->
      <!--<div class="marquee">-->
        <div style="float: left; width: 70%;margin-left: 20px;height: 56px;padding-top: 14px;">
          <RollNotice :text-arr="list" @fatherMethod="hotdetial"></RollNotice>
        </div>
        <!--<div class="marquee_box" ref="marquee_box">
          <ul class="marquee_list" :class="{marquee_top:animate}">
              <li v-for="(item,index) in list" :key="index">
                <a style="font-weight:normal" @click="hotdetial(item.id)">
                <p class="hotp">{{item.title}}</p></a></li>
          </ul>
        </div>-->
      <!--</div>-->
      </div>
    </div>
    <!-- 最新资讯，快捷入口 -->
    <div class="centers box">
      <div class="middleLunbo">
        <a-carousel autoplay  arrows :autoplaySpeed="autoplaySpeed">
              <div v-for="item in lblist" :key="item.id">
              <a @click="querydetial(item.id)"><img :src="image+item.coverimage" width="100%" style="height:387px"></a>
              </div>
        </a-carousel>
      </div>
      <div class="rightList">
        <div class="zxzx">最新动态
          <a @click="more"><img  style="margin-right:20px;margin-top:25px;float:right" src="../../images/more.png"></a>
        </div>
        <!-- <a-divider /> -->
        <p class="h3b"></p>
        <div class="zxzxlist" >
        <ul v-for="item in zxzxlist" :key="item.id" >
          <a  style="font-weight:normal;color:#373737" @click="zxzxbyid(item.id)"><li class="zxli"><span class="zxzxli" :title="item.title">{{item.title}}</span><span class="fright">{{item.publishdate}}</span></li></a>
        </ul>
        </div>
      </div>
      <div class="kjrk">
        <div class="zxzx">快捷入口
        </div>
        <p class="h3b"></p>
        <div class="ztk">
          <button class="kjbtn" @click="sqbzbtn">
            <a style="font-weight:normal;font-size: 20px;color:black;">
              <img class="imagecbz" src="../../images/icon_3.png">
              <img class="copycbz" src="../../images/icon_3copy.png">
              <div style="font-size:20px;margin-left:70px">申请标准</div></a></button>
        </div>
        <div class="kj">
          <button class="kjbtn" @click="cbzbtn"><a style="font-weight:normal;font-size: 20px;color:black;">
            <img  src="../../images/icon_1.png" class="imagecbz">
            <img  src="../../images/icon_1copy.png" class="copycbz">
            <div style="font-size:20px;margin-left:70px">查标准</div></a></button>
        </div>

        <div class="ztk">
          <button class="kjbtn" @click="ztkbtn">
            <a style="font-weight:normal;font-size: 20px;color:black;">
              <img class="imagecbz" src="../../images/icon_2.png">
              <img class="copycbz" src="../../images/icon_2copy.png">
              <div style="font-size:20px;margin-left:70px">专题库</div></a></button>
        </div>


        <div class="ztk">
          <button class="kjbtn" @click="gybtn">
            <a style="font-weight:normal;font-size: 20px;color:black;">
              <img class="imagecbz" src="../../images/icon_4.png">
              <img class="copycbz" src="../../images/icon_4.png">
              <div style="font-size:20px;margin-left:70px">关于我们</div></a></button>
        </div>
      </div>
    </div>
    <!-- 水产专题 -->
    <div class="scbox">
      <div class="sczt">水产专题<br>
      <span class="eng">Special Topics On Aquatic Products</span>
      <div class="ztlist">
        <a @click="xczx" style="font-weight:normal;color:white"><li>乡村振兴</li></a>
        <a @click="hyqs" style="font-weight:normal;color:white"><li>海洋强省</li></a>
        <a @click="ggfw" style="font-weight:normal;color:white"><li>公共服务</li></a>
      </div>
      </div>
    </div>
    <!-- 水产标准，联系我们 -->
    <div class="cbox centers1">
      <div class="bzList">
        <div class="scbz">水产标准
          <a @click="scbzmore"><img style="margin-right:20px;margin-top:25px;float:right" src="../../images/more.png"></a>
        </div>
        <p class="h3b"></p>
        <div class="scbzlist" >
        <ul v-for="item in scbz" :key="item.id" >
          <!-- <li>{{item.standardname}}<span class="fright">{{item.spublishdate}}</span></li> -->
          <li class="scbzlii"><span class="scbzli" :title="item.standardname">{{item.standardname}}</span><span class="fright" style="margin-right:12px">{{item.spublishdate}}</span></li>
          <!-- <li>节能环保型循环水养殖工程装备与关键技术<span class="fright">2021-07-12</span></li>
          <li>节能环保型循环水养殖工程装备与关键技术<span class="fright">2021-07-12</span></li>
          <li>节能环保型循环水养殖工程装备与关键技术<span class="fright">2021-07-12</span></li>
          <li>节能环保型循环水养殖工程装备与关键技术<span class="fright">2021-07-12</span></li>
          <li>节能环保型循环水养殖工程装备与关键技术<span class="fright">2021-07-12</span></li>
          <li>节能环保型循环水养殖工程装备与关键技术<span class="fright">2021-07-12</span></li>
          <li>节能环保型循环水养殖工程装备与关键技术<span class="fright">2021-07-12</span></li>
          <li>节能环保型循环水养殖工程装备与关键技术<span class="fright">2021-07-12</span></li>
          <li>节能环保型循环水养殖工程装备与关键技术<span class="fright">2021-07-12</span></li> -->
        </ul>
        </div>
      </div>
      <div class="contact">
        <div class="lxwm"><img src="../../images/contact_icon.png">
        联系我们
        </div>
        <a @click="wtfk"><div class="contact3"></div></a>
        <div class="contact2">
        </div>
        <div class="contact1">
        </div>
      </div>
    </div>
    <!-- 培训宣贯 -->
    <div class="pxgx">
      <div class="pxxgbox">
      <!-- <div class="pxList"> -->
        <div class="pxf">培训宣贯<p class="h3b"></p>
        <div class="pxcard" >
          <ul >
              <li v-for="(item,index) in pxxglist" :key="item.id"  >
                <a  @mouseenter="changePxxgLb(index)" @mouseleave="changePxxgLbRemove()" @click="pxdetial(item.id)" style="color:black">
                <span class="zxzxli1" :title="item.traintitle" >
                <img src="../../images/icon_lunbo.png" class="pximage">
                {{item.traintitle}}</span>
                </a>
              </li>
          </ul>
        </div>
        </div>
        <div class="pximg">
          <!-- <img src="../../images/model_2.png"> -->
          <a-carousel autoplay :autoplaySpeed="autoplaySpeed" ref="pxlb" >
              <div v-for="item in pxxglist" :key="item.id">
              <a @click="pxdetial(item.id)"><img :src="image+item.coverimage"  width="100%" style="height:290px" ></a>
              </div>
          </a-carousel>
        </div>
      <!-- </div> -->
      </div>
    </div>
    <!-- 友情链接 -->
    <div class="content yqbox">
      <!-- <div class="yqlj"> -->
        <div class="lj">
        <img src="../../images/link_icon.png" style="margin-bottom:10px">
        <span class="zxzx">友情链接</span>
        </div>
        <ul>
          <a @click="agriculture">
          <div class="yqa" >
            <div id="left"></div>
            <div id="right"></div>
            <div id="bottom"></div>
            <div id="rightx"></div>
            <div id="topcenter"></div>
            <div id="bottomcenter"></div>
            <a>中华人民共和国农业农村部</a>
          </div>
          </a>
          <a @click="chineseaquatic">
          <div class="yqa">
            <div id="left"></div>
            <div id="right"></div>
            <div id="bottom"></div>
            <div id="rightx"></div>
            <div id="topcenter"></div>
            <div id="bottomcenter"></div>
            <a>中国水产学会</a>
          </div>
          </a>
          <a @click="nationwide">
          <div class="yqa">
            <div id="left"></div>
            <div id="right"></div>
            <div id="bottom"></div>
            <div id="rightx"></div>
            <div id="topcenter"></div>
            <div id="bottomcenter"></div>
            <a>全国水产技术推广总站</a>
          </div>
          </a>
          <a @click="sdaquatic">
          <div class="yqa">
            <div id="left"></div>
            <div id="right"></div>
            <div id="bottom"></div>
            <div id="rightx"></div>
            <div id="topcenter"></div>
            <div id="bottomcenter"></div>
            <a>山东水产学会</a>
          </div>
          </a>
          <a @click="sdscience">
          <div class="yqa">
            <div id="left"></div>
            <div id="right"></div>
            <div id="bottom"></div>
            <div id="rightx"></div>
            <div id="topcenter"></div>
            <div id="bottomcenter"></div>
            <a>山东省科学技术协会</a>
          </div>
          </a>
        </ul>
        <ul>
          <a @click="sdagriculture">
          <div class="yqa">
            <div id="left"></div>
            <div id="right"></div>
            <div id="bottom"></div>
            <div id="rightx"></div>
            <div id="topcenter"></div>
            <div id="bottomcenter"></div>
            <a>山东省农业农村厅</a>
          </div>
          </a>
          <a @click="gjbzhwyh">
          <div class="yqa">
            <div id="left"></div>
            <div id="right"></div>
            <div id="bottom"></div>
            <div id="rightx"></div>
            <div id="topcenter"></div>
            <div id="bottomcenter"></div>
            <a>国家标准化管理委员会</a>
          </div>
          </a>
          <a @click="standardization">
          <div class="yqa">
            <div id="left"></div>
            <div id="right"></div>
            <div id="bottom"></div>
            <div id="rightx"></div>
            <div id="topcenter"></div>
            <div id="bottomcenter"></div>
            <a>中国标准化研究院</a>
          </div>
          </a>
          <a @click="team">
          <div class="yqa">
            <div id="left"></div>
            <div id="right"></div>
            <div id="bottom"></div>
            <div id="rightx"></div>
            <div id="topcenter"></div>
            <div id="bottomcenter"></div>
            <a>全国团体标准信息平台</a>
          </div>
          </a>
          <a @click="sdstandardization">
          <div class="yqa">
            <div id="left"></div>
            <div id="right"></div>
            <div id="bottom"></div>
            <div id="rightx"></div>
            <div id="topcenter"></div>
            <div id="bottomcenter"></div>
            <a>山东省标准化研究院</a>
          </div>
          </a>
        </ul>
      <!-- </div> -->

    </div>

  </div>
</template>



<script>
import http from '../../js/axios'
import LoginAccount from '../login/moudles/LoginAccount.vue'
import UserLogin from '../login/moudles/UserLogin.vue'
import RollNotice from '../../router/rollNotice/rollNotice'

export default {
  name: 'App',
  components: {
    LoginAccount,
    UserLogin,
    RollNotice
  },
  data(){
    return{
      animate: false,
      showNum: 1, // 可见列表条数
      list: [
      ],
      lblist:[],
      zxzxlist:[],
      pxxglist:[],
      stop:null,
      autoplaySpeed:1000,
      image:'',
      scbz:[],
      banner:'',
      mode:'top',
      edit:false
    }
  },
  computed:{
    text() {
    return {
        id: this.number,
        val: this.arr[this.number],
      }
    },
    // autoplaySpeed(){
    //   return  1000
    // },
  },
  created(){
    // 页面显示
    this.image = http.imageURL
    this.queryBanner()
    //setInterval(this.showMarquee, 3000)
    this.queryAllRdgz()
    this.queryLb()
    this.queryAllZxzx()
    this.queryLbClass()
    this.queryScbz()
  },
  mounted () {
    // 可见数据高度
    // this.$refs.marquee_box.style.height = this.showNum * 30 + 'px'
  },
  watch: {

  },
  methods:{
    sqbzbtn(){
      // var arr = document.cookie.split('; ');
      // if(arr.length>1){
      //   console.log("可以申请标准！")
      // }else{
      //   this.$message.warning("您尚未登录，请登录后再试！")
      // }
      // this.$router.push({name:'aquaticstandards'});
      // window.location.href = "http://localhost:3000/aquaticdeclaration/modules/AquaticApplicationForm?method=sqbz"
      //window.location.href = "http://localhost:3000/aquaticdeclaration/modules/AquaticApplicationForm"
      window.open("http://bz.sdscxh.cn/aquatic-front/aquaticdeclaration/modules/AquaticApplicationForm");
    },
    queryBanner(){
      http.get('/queryBanner',{}
      ).then((res) => {
        this.banner = res.data.result.records[0].homeimage
      })
    },
    hotdetial(id){
      //window.open('aquaticstate?id='+id)
      this.$router.push({ path: "aquaticstate", query: {id: id}});
    },
    cbzbtn(){
      this.$router.push({name:'aquaticstandards'});
    },
    wtfk(){
      this.$router.push({name:'aquaticzxfw'});
    },
    queryScbz(){
      http.get('/queryStandardsSy',{}
      ).then((res) => {
        this.scbz = res.data.result
      })
    },
    gjbzhwyh(){
      window.open("http://www.sac.gov.cn/")
    },
    sdscience(){
      window.open("http://www.sdast.org.cn/")
    },
    sdstandardization(){
      window.open("http://www.sdis.cn/")
    },
    team(){
      window.open("http://www.ttbz.org.cn/")
    },
    standardization(){
      window.open("https://www.cnis.ac.cn/pcindex/")
    },
    sdagriculture(){
      window.open("http://nync.shandong.gov.cn/")
    },
    sdaquatic(){
      window.open("http://www.sdscxh.cn/scxh/#/index")
    },
    nationwide(){
      window.open("http://www.nftec.agri.cn/")
    },
    chineseaquatic(){
      window.open("http://www.csfish.org.cn/")
    },
    agriculture(){
      window.open("http://www.moa.gov.cn/")
    },
    pxdetial(id){
      var arr = document.cookie.split('; ');
      if(arr.length>1){
        window.open('aquatictraindetial?id='+id)
      }else{
        this.$message.warning("您尚未登录，请登录后再试！")
      }
    },
    changePxxgLbRemove(){
      this.autoplaySpeed=1000
    },
    onChange(a){
      console.log(a)
    },
    changePxxgLb(index){
      this.autoplaySpeed=5000
      this.$refs.pxlb.goTo(index)
    },
    queryLbClass(){
      http.get('/queryLbClass',{}
      ).then((res) => {
          this.pxxglist = res.data.result
      })
    },
    querydetial(id){
      //window.open('aquaticstate?id='+id)
      this.$router.push({ path: "aquaticstate", query: {id: id}});
    },
    gybtn(){
      this.$router.push({name:'aquaticcommission'});
    },
    ztkbtn(){
      this.$router.push({name:'aquaticspecial'});
    },
    zxzxbyid(id){
      //window.open('aquaticstate?id='+id)
      this.$router.push({ path: "aquaticstate", query: {id: id}});
    },
    more(){
      this.$router.push({name:'aquaticstate'});
    },
    scbzmore(){
      this.$router.push({name:'aquaticstandards'});
    },
    queryAllZxzx(){
      http.get('/queryAllZxzx',{}
      ).then((res) => {
          this.zxzxlist = res.data.result
      })
    },
    queryAllRdgz(){
      http.get('/queryAllRdgz',{}
      ).then((res) => {
          this.list = res.data.result
      })
    },
    queryLb(){
      http.get('/queryAllLb',{}
      ).then((res) => {
          this.lblist = res.data.result
      })
    },
    ggfw(){
      this.$router.push({name:'aquaticspecial',params:{sczt:'公共服务'}});
    },
    hyqs(){
      this.$router.push({name:'aquaticspecial',params:{sczt:'海洋强省'}});
    },
    xczx(){
      this.$router.push({name:'aquaticspecial',params:{sczt:'乡村振兴'}});
    },
    button(){
      console.log("点击一次！")
    },
    // 处理数组方法
    showMarquee () {
      this.animate = true
      this.list.push(this.list[0])
      setTimeout(() => {
        this.list.shift()
        this.animate = false
      }, 1000)
    }
  }
}
</script>


<style>
  @import "../../config/common.css"


/* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /* margin-top: 15px; */


</style>



// WEBPACK FOOTER //
// src/views/dashboard/Home.vue